import {Injectable} from '@angular/core';
import {Http, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
// import { Observer } from 'rxjs/Observer';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import * as Config from '../../app/app.config';
import {AuthProvider} from '../auth/auth';

import {Storage} from '@ionic/storage';
import {Platform} from 'ionic-angular';

/*
  Generated class for the ProofServerProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class SubscriptionServerProvider {

  // private medias: MediaItem[];
  // private mediasSuccess: any[];

  constructor(
    private http: Http,
    private auth: AuthProvider,
    // private proofProvider: ProofProvider,
    private storage: Storage,
    private platform: Platform,
    // private mediaProvider: MediaProvider,
    // private file: File,
    // private fileProvider: FileProvider
  ) {
    console.log('Hello SubscriptionServerProvider Provider');
  }

  /**
   * Fetch all. Returns the subscriptions.
   */
  public fetchAll() {
    let that = this;

    return Observable.create((observer: any) => {
      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.get(Config.baseUrl + '/subscriptions', {headers: headers})
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  public getCertificateUrl(id: number, certificateToken: string) {
    // var headers = new Headers();
    // headers.append('Authorization', 'Bearer ' + this.auth.getToken());

    let url = Config.baseUrl + '/subscriptions/' + id + '/certificate?token=' + certificateToken;

    return url;
  }

  /**
   * Retake. Try to retake the proof of subscription.
   *
   * @param $subscriptionId
   */
  public retake(id: number) {
    let that = this;

    return Observable.create((observer: any) => {
      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.get(Config.baseUrl + '/subscriptions/' + id + '/retake', {headers: headers})
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  /**
   * Renew. Try to renew the subscription.
   *
   * @param $subscriptionId
   */
  public renew(id: number) {
    let that = this;

    return Observable.create((observer: any) => {
      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.get(Config.baseUrl + '/subscriptions/' + id + '/renew', {headers: headers})
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  public complement(id: number) {
    let that = this;

    return Observable.create((observer: any) => {
      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.get(Config.baseUrl + '/subscriptions/' + id + '/complement', {headers: headers})
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          console.log("Prova Complemento ------->", data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  /**
   * Fetch Proofs That Can Create. Returns the proofs that can create.
   */
  public fetchProofsThatCanCreate(modalityId: number) {
    let that = this;

    return Observable.create((observer: any) => {
      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.get(Config.baseUrl + '/subscriptions/fetchproofsthatcancreate/' + modalityId, {headers: headers})
        .map((res: Response) => res.json())
        .subscribe((data) => {

          observer.next(data);
          console.log('modalityId ------> ', modalityId);
          console.log('fetchproofsthatcancreate ------> ', data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  /**
   * Fetch Proofs Details. Returns the details (way to do, prices) of a proof identified by {proofId}.
   *
   * @param $proofId
   */
  public fetchProofDetails(id: number, kind: string) {
    let that = this;

    return Observable.create((observer: any) => {
      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.get(Config.baseUrl + '/subscriptions/proof/' + id + '/details/' + kind, {headers: headers})
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  /**
   * Fetch Proofs Details. Returns the details (way to do, prices) of a proof identified by {proofId}.
   *
   * @param $proofId
   */
  public fetchProofPriceDetails(id: number, kind: string, accesskind: string, camera: boolean) {
    let that = this;
    console.log('chegou aqui -> fetchProofPriceDetails')
    return Observable.create((observer: any) => {
      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.get(Config.baseUrl + '/subscriptions/proof/' + id + '/detailsprice/' + kind + '/' + accesskind + '/' + camera, {headers: headers})
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          observer.complete();
          console.log('fetchProofPriceDetails -------->', data);
        }, (error: any) => {
          console.log('deu erro -> fetchProofPriceDetails')
          observer.error(new Error(error.status));
        });
    });
  }

  /**
   * Validate Federal Code And Course Code Bradesco. Validate Federal Code And Course Code of Bradesco (it could be directly create a subscription).
   */
  public validateFederalCodeAndCourseCodeBradesco(formData: any) {
    let that = this;

    return Observable.create((observer: any) => {
      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.post(Config.baseUrl + '/subscriptions/validatefederalcodeandcoursecodebradesco', formData, {headers: headers})
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  public subscriptionByPayment(formData: any) {
    let that = this;

    return Observable.create((observer: any) => {
      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.post(Config.baseUrl + '/subscriptions/subscriptionbypayment', formData, {headers: headers})
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          observer.complete();
          console.log("DATA FROM SUBS SERVER : ", data);
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }


  public doSubByPayment(formData: any) {
    let that = this;

    return Observable.create((observer: any) => {
      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.post(Config.baseUrl + '/subscriptions/dosubbypayment', formData, {headers: headers})
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  public doSubByPaymentFree(formData: any) {
    let that = this;

    return Observable.create((observer: any) => {
      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.post(Config.baseUrl + '/subscriptions/dosubbypaymentfree', formData, {headers: headers})
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  public doSubByPaymentBillet(formData: any) {
    let that = this;

    return Observable.create((observer: any) => {
      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.post(Config.baseUrl + '/subscriptions/dosubbypaymentbillet', formData, {headers: headers})
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  public doSubByPaymentCreditCard(formData: any) {
    let that = this;

    return Observable.create((observer: any) => {
      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.post(Config.baseUrl + '/subscriptions/dosubypaymentcreditcard', formData, {headers: headers})
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  public doSubByPaymentPix(formData: any) {
    let that = this;

    return Observable.create((observer: any) => {
      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.post(Config.baseUrl + '/subscriptions/dosubypaymentpix', formData, {headers: headers})
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  // public processedPayment(id: number) {
  //   let that = this;
  //
  //   return Observable.create((observer: any) => {
  //     let headers = that.auth.createApplicationHeadersWithBearer();
  //
  //     that.http.post(Config.baseUrl + '/subscriptions/processedpayment/' + id, { headers: headers })
  //       .map((res: Response) => res.json())
  //       .subscribe((data) => {
  //         observer.next(data);
  //         observer.complete();
  //       }, (error: any) => {
  //         observer.error(new Error(error.status));
  //       });
  //   });
  // }


  public processedPayment(id: number) {
    let that = this;

    return Observable.create((observer: any) => {
      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.get(Config.baseUrl + '/subscriptions/processedpayment/' + id, {headers: headers})
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          console.log("processedPayment ------->", data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  /**
   * Create. Create a subscription (with details of proof and payment method).
   */
  public create(formData: any) {
    let that = this;

    return Observable.create((observer: any) => {
      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.post(Config.baseUrl + '/subscriptions', formData, {headers: headers})
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          console.log(data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  /**
   * Fetch. Fetch subscription details.
   *
   * @param $subscriptionId
   */
  public fetch(id: number) {
    let that = this;

    return Observable.create((observer: any) => {
      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.get(Config.baseUrl + '/subscriptions/' + id, {headers: headers})
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  /**
   * Edit. Edit a subscription (if it is enabled).
   *
   * @param $subscriptionId
   */
  public edit(id: number, formData: any) {
    let that = this;

    return Observable.create((observer: any) => {
      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.put(Config.baseUrl + '/subscriptions/' + id, formData, {headers: headers})
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  public validateUserAggregateAffiliatedFederalCode(proofId: number, companyFederalCode: string, userFederalCode: string) {
    let that = this;

    return Observable.create((observer: any) => {
      let headers = that.auth.createApplicationHeadersWithBearer();
      headers.append('Access-Control-Allow-Origin', '*');
      let formData = {
        'proof_id': proofId,
        'company_federal_code': companyFederalCode,
        'user_federal_code': userFederalCode
      };

      that.http.post(Config.baseUrl + '/subscriptions/validateuseraggregateaffiliatedfederalcode', formData, {headers: headers})
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  public rmSubscription(subscriptionId: number) {
    let that = this;

    return Observable.create((observer: any) => {
      let headers = that.auth.createApplicationHeadersWithBearer();
      let formData = {'subscription_id': subscriptionId};

      that.http.post(Config.baseUrl + '/subscriptions/remove', formData, {headers: headers})
        .map((res: Response) => res.json())
        .subscribe((data) => {
          console.log("remover subscription ------->", data);
          observer.next(data);
          observer.complete();
        }, (error: any) => {
          console.log(error)
          observer.error(new Error(error.status));
        });
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/subscription-server/subscription-server.ts